import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = 'EUR') {
  const symbols = { EUR: '€', USD: '$', GBP: '£', CHF: 'CHF', DOP: 'RD$', COP: '$', MXN: '$', ARS: '$', CAD: 'C$', BRL: 'R$', CLP: '$', PEN: 'S/', UYU: '$U', JPY: '¥', CNY: '¥', INR: '₹', AUD: 'A$', SEK: 'kr' };
  const symbol = symbols[currency] || currency;
  const formatted = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(amount));
  return `${amount < 0 ? '-' : ''}${symbol}${formatted}`;
}

export function formatDate(dateString, locale = 'es-ES') {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(date);
}

export function formatDateShort(dateString, locale = 'es-ES') {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat(locale, {
    month: 'short',
    day: 'numeric',
  }).format(date);
}

export function formatPercent(value) {
  return `${value >= 0 ? '+' : ''}${value.toFixed(1)}%`;
}

export function getDateRange(period = 'month') {
  const now = new Date();
  const start = new Date();

  switch (period) {
    case 'week':
      start.setDate(now.getDate() - 7);
      break;
    case 'month':
      start.setMonth(now.getMonth(), 1);
      break;
    case 'quarter':
      start.setMonth(Math.floor(now.getMonth() / 3) * 3, 1);
      break;
    case 'year':
      start.setMonth(0, 1);
      break;
    default:
      start.setMonth(now.getMonth(), 1);
  }

  return {
    start: start.toISOString(),
    end: now.toISOString(),
  };
}

export function classifyAmount(amount, type) {
  if (type === 'income') return 'text-emerald-600';
  if (type === 'expense') return 'text-red-500';
  return 'text-slate-600';
}

export function getStatusColor(value, thresholds = { good: 0, warning: -10 }) {
  if (value >= thresholds.good) return 'text-emerald-600 bg-emerald-50';
  if (value >= thresholds.warning) return 'text-amber-600 bg-amber-50';
  return 'text-red-600 bg-red-50';
}

export function getCurrencySymbol(currency) {
  const symbols = { EUR: '€', USD: '$', GBP: '£', CHF: 'CHF', DOP: 'RD$', COP: '$', MXN: '$', ARS: '$', CAD: 'C$', BRL: 'R$', CLP: '$', PEN: 'S/', UYU: '$U', JPY: '¥', CNY: '¥', INR: '₹', AUD: 'A$', SEK: 'kr' };
  return symbols[currency] || currency;
}
